import { render, staticRenderFns } from "./ExtractionDocumentConfiguration.vue?vue&type=template&id=c978aa3a"
import script from "./ExtractionDocumentConfiguration.vue?vue&type=script&lang=js"
export * from "./ExtractionDocumentConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports